import React from 'react';
import ButtonSpinner from '../ButtonSpinner';
import './RoundedButton.scss';

export default function RoundedButton ({ children, solid, busy, ...rest }) {
    return (
        <button {...rest} className={[solid ? 'solid' : '']}>
            {
                busy ? <ButtonSpinner/> : null
            }
            <span className="btn-content" style={ busy ? {"visibility": "hidden"} : null}>{children}</span>
        </button>
    );
};